"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceBreakdownToJSON = exports.PriceBreakdownFromJSONTyped = exports.PriceBreakdownFromJSON = exports.instanceOfPriceBreakdown = void 0;
var Money_1 = require("./Money");
/**
 * Check if a given object implements the PriceBreakdown interface.
 */
function instanceOfPriceBreakdown(value) {
    var isInstance = true;
    isInstance = isInstance && "baseFare" in value;
    isInstance = isInstance && "discount" in value;
    isInstance = isInstance && "fee" in value;
    isInstance = isInstance && "tax" in value;
    isInstance = isInstance && "total" in value;
    return isInstance;
}
exports.instanceOfPriceBreakdown = instanceOfPriceBreakdown;
function PriceBreakdownFromJSON(json) {
    return PriceBreakdownFromJSONTyped(json, false);
}
exports.PriceBreakdownFromJSON = PriceBreakdownFromJSON;
function PriceBreakdownFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'baseFare': (0, Money_1.MoneyFromJSON)(json['baseFare']),
        'discount': (0, Money_1.MoneyFromJSON)(json['discount']),
        'fee': (0, Money_1.MoneyFromJSON)(json['fee']),
        'tax': (0, Money_1.MoneyFromJSON)(json['tax']),
        'total': (0, Money_1.MoneyFromJSON)(json['total']),
    };
}
exports.PriceBreakdownFromJSONTyped = PriceBreakdownFromJSONTyped;
function PriceBreakdownToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'baseFare': (0, Money_1.MoneyToJSON)(value.baseFare),
        'discount': (0, Money_1.MoneyToJSON)(value.discount),
        'fee': (0, Money_1.MoneyToJSON)(value.fee),
        'tax': (0, Money_1.MoneyToJSON)(value.tax),
        'total': (0, Money_1.MoneyToJSON)(value.total),
    };
}
exports.PriceBreakdownToJSON = PriceBreakdownToJSON;
